module.exports = __webpack_public_path__ + "static/countries-info-b3faab4700948de5411ad876c7290a6b.gif";